<template>
	<div class="tab-text">
		<section>
			<h1 class="py-5">Role</h1>
			<div style="text-align:right">
				<vs-button @click="rolePopup = true" color="primary">Add Role</vs-button>
			</div>

			<b-table ref="table" striped hover fixed responsive show-empty sort-icon-left :selectable="false"
				:items="roleList" :fields="roleColumns">
				<template v-slot:table-busy>
					<div class="text-center text-danger my-2" style="height: 600px">
						<b-spinner class="align-middle"></b-spinner>
						<div class="mt-3">
							<strong>Loading...</strong>
						</div>
					</div>
				</template>

				<template v-slot:cell(action)="data">
					<vs-button @click="onEditRolePressed(data)" color="primary" type="flat">Edit</vs-button>
					<vs-button @click="onDeleteRolePressed(data)" color="primary" type="flat">Delete</vs-button>
				</template>
			</b-table>
		</section>
		<vs-divider></vs-divider>
		<div class="vx-row pt-2 mt-0">
			<div class="vx-col w-full ml-auto">
				<vs-button class="mr-3 mb-2" @click="onSavePressed()">Save</vs-button>
				<vs-button class="mr-3 mb-2" type="border" @click="onCancelPressed()">Cancel</vs-button>
			</div>
		</div>

		<vs-popup title="Role" :active.sync="rolePopup">
			<div style="min-height: 100px;" class="m-5" v-if="event != null">
				<div class="mb-6">
					<span>Name</span>
					<vs-input class="mt-2" v-validate="'required'" name="name" v-model="createRoleForm.name"
						style="width: 100%" :maxlength="100" />
					<span class="text-danger text-sm" v-show="errors.has('name')">
						{{ errors.first('name') }}
					</span>
				</div>
				<div class="mb-6">
					<span>Slug</span>
					<vs-input class="mt-2" v-validate="'required'" name="slug" v-model="createRoleForm.slug"
						:disabled="createRoleForm.edit" style="width: 100%" :maxlength="100" />
					<span class="text-danger text-sm" v-show="errors.has('slug')">
						{{ errors.first('slug') }}
					</span>
				</div>
				<div class="mb-6">
					<span>Color</span>
					<vs-select class="selectExample mt-2" v-validate="'required'" name="color"
						v-model="createRoleForm.color" style="width:100%;">
						<vs-select-item :key="index" :value="ele.text" :text="ele.text" v-for="(ele, index) in colorList" />
					</vs-select>
					<span class="text-danger text-sm" v-show="errors.has('color')">
						{{ errors.first('color') }}
					</span>
				</div>
				<div class="mb-6">
					<span>Remark</span>
					<vs-textarea class="mt-2 remark-textarea" v-validate="'required'" name="remark"
						v-model="createRoleForm.remark" rows="5" style="width: 100%" />
					<span class="text-danger text-sm" v-show="errors.has('remark')">
						{{ errors.first('remark') }}
					</span>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Listing Status</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<ul class="demo-alignment">
							<li>
								<vs-radio vs-name="radios-listing-status" vs-value="1"
									v-model="createRoleForm.listing_status" aria-checked="true">Yes</vs-radio>
							</li>
							<li>
								<vs-radio vs-name="radios-listing-status" vs-value="0"
									v-model="createRoleForm.listing_status">No</vs-radio>
							</li>
						</ul>
					</div>
				</div>
				<div class="mb-6">
					<span>Check In Type</span>
					<vs-select class="selectExample mt-2" v-validate="'required'" name="checkin_type"
						v-model="createRoleForm.checkin_type" style="width:100%;">
						<vs-select-item :key="index" :value="ele.value" :text="ele.text"
							v-for="(ele, index) in checkInTypeList" />
					</vs-select>
					<span class="text-danger text-sm" v-show="errors.has('checkin_type')">
						{{ errors.first('checkin_type') }}
					</span>
				</div>

        <div class="mb-6">
					<span>Weight</span>
					<vs-input type="number" class="mt-2" v-validate="{ min_value: 0 }" name="weight" v-model="createRoleForm.weight" style="width: 100%"  />
					<span class="text-danger text-sm" v-show="errors.has('weight')">
						{{ errors.first('weight') }}
					</span>
				</div>

				<vs-divider></vs-divider>
				<div class="vx-row pt-2 mt-0">
					<div class="vx-col w-full ml-auto">
						<vs-button class="mr-3 mb-2" color="primary" type="filled"
							@click="onSaveCreateRolePressed()">
              {{ !createRoleForm.edit ?'Add':'Save' }}
            </vs-button>
						<vs-button class="mr-3 mb-2" type="border" @click="rolePopup = false">Cancel
						</vs-button>
					</div>
				</div>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import Service from "@/services";

export default {
	props: {
		event: null,
	},
	data() {
		return {
			roleValidated: false,
			rolePopup: false,
			checkInTypeList: [
				{ text: "Check In Only", value: "checkin_only" },
				{ text: "Check In and Print Badge", value: "checkin_print_badge" },
				{ text: "Check-in and Receive Wristband", value: "checkin_wristband" },
				{ text: "Check-in and Receive RFID Wristband", value: "checkin_wristband_rfid" },
			],
			roleList: [],
			roleColumns: [
				{ label: "Name", key: "name", sortable: false },
				{ label: "Slug", key: "slug", sortable: false },
				{ label: "Color", key: "color", sortable: false },
				{ label: "Remark", key: "remark", sortable: false },
				{ label: "Listing Status", key: "listing_status", sortable: false },
				{ label: "Checkin Type", key: "checkin_type_text", sortable: false },
        { label: "Weight", key: "weight", sortable: false },
				{ label: "Action", key: "action", sortable: false }
			],
			colorList: [
				{ text: "BLACK", value: "#000000" },
				{ text: "WHITE", value: "#FFFFFF" },
				{ text: "GOLD", value: "#ffd700" },
				{ text: "SILVER", value: "#c0c0c0" },
				{ text: "GREEN", value: "#008000" },
				{ text: "LIGHT GREEN", value: "#00FF00" },
				{ text: "BLUE", value: "#0000FF" },
				{ text: "LIGHT BLUE", value: "#87ceeb" },
				{ text: "AQUA", value: "#00FFFF" },
				{ text: "ORANGE", value: "#ffa500" },
				{ text: "PURPLE", value: "#800080" },
				{ text: "YELLOW", value: "#FFFF00" },
				{ text: "RED", value: "#FF0000" },
				{ text: "PINK", value: "#ff69b4" },
			],
			createRoleForm: {
				name: null,
				slug: null,
				color: null,
				color_code: null,
				remark: null,
				listing_status: 1,
				checkin_type: null,
				checkin_type_text: null,
        weight: null,
			}
		};
	},
	watch: {
		'$data.rolePopup': {
			handler: function (state) {
				this.$validator.reset();
				if (!state) {
					this.createRoleForm = {
						name: null,
						slug: null,
						color: null,
						color_code: null,
						remark: null,
						listing_status: 1,
						checkin_type: null,
						checkin_type_text: null,
            weight: null
					}
				}
			},
		}
	},
	created() {
		const jsonRole = JSON.parse(this.event.ticket_role);
		const roles = Object.keys(jsonRole).map((key) => jsonRole[key]);
		this.roleList = roles.map((role) => {
			const checkinType = this.checkInTypeList.find((ele) => ele.value === role.checkin_type);
			return checkinType ? { ...role, checkin_type_text: checkinType.text } : role;
		})
	},
	methods: {
		onCreateRolePressed() {
			this.rolePopup = true;
		},
		async onSaveCreateRolePressed() {
			const validate = await this.$validator.validateAll();
			if (!validate) return;
			const colorCode = this.colorList.find((ele) => ele.text === this.createRoleForm.color);
			this.createRoleForm.color_code = colorCode.value;

			if (this.createRoleForm.edit) {
				const index = this.roleList.findIndex((ele) => ele.slug === this.createRoleForm.slug);
				const checkinType = this.checkInTypeList.find((ele) => ele.value === this.createRoleForm.checkin_type);
				this.roleList[index] = { ...this.createRoleForm, checkin_type_text: checkinType ? checkinType.text : null };
				this.roleList = [...this.roleList];
				this.rolePopup = false;
				return;
			}

			const isExist = this.roleList.find((role) => role.slug === this.createRoleForm.slug);
			if (isExist) {
				this.$vs.notify({
					title: 'Error',
					text: 'Role is exist',
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger'
				})
				return;
			}

			this.roleList.push({ ...this.createRoleForm });
			this.rolePopup = false;
		},
		onEditRolePressed(role) {
			this.createRoleForm = { ...role.item, edit: true };
			this.rolePopup = true;
		},
		onDeleteRolePressed(role) {
			const index = this.roleList.findIndex((ele) => ele.slug === role.item.slug);
			this.roleList.splice(index, 1);
		},
		async onSavePressed() {
			const roleObject = {};
			this.roleList.forEach((role) => {
				if (role.edit) delete role.edit;
				if (role.checkin_type_text) delete role.checkin_type_text;
				role.listing_status = parseInt(role.listing_status);
				roleObject[role.slug] = role;
			});

			const data = { ticket_role: roleObject }
			try {
				this.$vs.loading();
				const res = await Service.Event.updateEventRole(data, this.event.e)
				if (res.success) {
					this.$emit("loadEvent");
					this.$vs.notify({
						color: 'success',
						title: 'Complete',
						text: 'Edit check-in success',
					})
				}
			} catch (error) {
				this.$vs.notify({
					title: "Oops!",
					text: "ERROR : " + error.error,
					color: "danger"
				});
			} finally {
				this.$vs.loading.close();
			}
		},
		onCancelPressed() {
			this.$router.push(`/dash`)
		},
	}
};
</script>

<style lang="scss" scoped>
.remark-textarea {
	margin-bottom: unset !important;
}

.grid-button-upload {
	.grid-button-upload {
		.grid-button-upload {
			margin-top: 8px;
			display: grid;
			grid-template-columns: repeat(2, min-content);
			grid-gap: 10px;
		}

		.vs-button {
			font-size: 10px !important;
		}

		input[type="file"] {
			display: none !important;
		}

		.popup-confirm {
			& div {
				width: 100%;
				text-align: center;
			}

			& .wrap-button {
				display: grid;
				grid-template-columns: repeat(2, 25%);
				grid-gap: 8px;
				justify-content: flex-end;
				margin-top: 20px;

			}
		}
	}
}
</style>
